import { FlowActionTypes } from '../store/flow/action-types';
import { fetchVisitorContext } from '../store/visitor-context/action-creators';
export const VisitorContextMiddleware = store => next => action => {
  if (action.type === FlowActionTypes.Load) {
    store.dispatch(fetchVisitorContext());
  }
  return next(action);
};